﻿import React from 'react';
import { StrikeThroughHeader } from '../../../../components/Headers/strikethrough-header/strikethrough-header';
import AgentRequestsTable from './AgentRequestsTable';
import { useUser } from '../../../../context/UserContext';

const SecureFileDelivery = () => {
  const user = useUser();

  return (
    <>
      <StrikeThroughHeader>Secure File Delivery</StrikeThroughHeader>
      {!user.isHO && <AgentRequestsTable />}
    </>
  );
};
export default SecureFileDelivery;
